import React, { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { FlexRow } from '@portal/common/components';
import { AllDataTypes } from '@portal/common/models/data-type';
import { DataCondition } from '@portal/common/types';

import ConditionDropdown from '../../components/ConditionDropdown';
import _ from '../../locale';
import { changeConditions } from '../../store/data-explorer/actions';
import {
    getDataToolDataCollections,
    getSelectedConditions,
    getSelectedDataType,
} from '../../store/data-explorer/selectors';
import { getSelectedDataCollectionForDataTool } from '../../store/user-settings/selectors';

const ComorbidityConditionSelector: FC = () => {
    const dispatch = useDispatch();

    const dataCollections = useSelector(getDataToolDataCollections);
    const selectedConditions = useSelector(getSelectedConditions);
    const selectedDataCollection = useSelector(getSelectedDataCollectionForDataTool);
    const selectedDataType = useSelector(getSelectedDataType);

    const handleChange = (conditions: DataCondition[]): void => {
        dispatch(changeConditions(conditions));
    };

    if (!dataCollections || !dataCollections.length || !selectedDataCollection) {
        return null;
    }

    const filteredDatasets = selectedDataCollection.datasets.filter(
        (i) => selectedDataType === AllDataTypes || selectedDataType === i.data_type
    );

    return (
        <FlexRow itemsSpacing={30}>
            <div style={{ flexGrow: 1, position: 'relative' }}>
                <ConditionDropdown
                    key={
                        selectedDataCollection.id +
                        filteredDatasets.map((i) => i.data_type).toString()
                    }
                    label={_('comorbidity_condition_label')}
                    placeholder={_('comorbidity_condition_placeholder')}
                    datasets={filteredDatasets}
                    onChange={handleChange}
                    value={selectedConditions}
                    isMulti={false}
                    isSearchable
                    renderMenuHeader={() => null}
                />
            </div>
        </FlexRow>
    );
};

export default ComorbidityConditionSelector;
